import { useDebounceCallback } from "usehooks-ts"
import { useNexusNavigate } from "../../../hooks/useNexusNavigate"
import { DataReceiptSearchFilters, DataReceiptSearchFitlersAndPaging } from "./DataReceiptSearchFilters"

export const useDebouncedDataReceiptTableSearchField = <T extends keyof DataReceiptSearchFilters>(
    fieldName: T,
    field: DataReceiptSearchFitlersAndPaging[T],
    filters: DataReceiptSearchFitlersAndPaging,
) => {
    const nexusNavigate = useNexusNavigate()

    return useDebounceCallback((updatedField: DataReceiptSearchFitlersAndPaging[T]) => {
        let cleanedField: DataReceiptSearchFitlersAndPaging[T] = updatedField
        let validLength = true
        if (typeof cleanedField === "string") {
            validLength = cleanedField.length !== 1
            cleanedField = cleanedField.trim() as DataReceiptSearchFitlersAndPaging[T]
        }

        if (field !== cleanedField && validLength) {
            const searchWith: DataReceiptSearchFitlersAndPaging = {
                ...filters,
                page: 0,
            }
            searchWith[fieldName] = cleanedField
            nexusNavigate.searchDataReceipts(searchWith)
        }
    }, 800)
}
